module.exports = __webpack_public_path__ + "img/hr-V-L-135-unload-standup-top.a1314692.png";